"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BeaconProxy__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "beacon",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        stateMutability: "payable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "previousAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "AdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "beacon",
                type: "address",
            },
        ],
        name: "BeaconUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        stateMutability: "payable",
        type: "fallback",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class BeaconProxy__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(beacon, data, overrides) {
        return super.getDeployTransaction(beacon, data, overrides || {});
    }
    deploy(beacon, data, overrides) {
        return super.deploy(beacon, data, overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.BeaconProxy__factory = BeaconProxy__factory;
BeaconProxy__factory.bytecode = _bytecode;
BeaconProxy__factory.abi = _abi;
//# sourceMappingURL=BeaconProxy__factory.js.map